import { BlockWrapper, defineBlock } from "@smartfire/js-block-engine";
import { useTranslation } from "react-i18next";
import Button from "../button/block";
import { getHomeUrl } from "../shared/tools";
import style from "./block.module.scss";

const Block = () => {
  const { t } = useTranslation();

  return (
    <BlockWrapper.Div className={style.block}>
      <h1 className={style.title}>{t("404 Error")}</h1>
      <p className={style.text}>
        {t("The page you are looking for cannot be found")}.
      </p>
      <Button
        text={t("Return to homepage")}
        link={getHomeUrl()}
        type={"filled"}
      />
    </BlockWrapper.Div>
  );
};

export default defineBlock({
  Block,
  smartProps: {},
  setup: {
    title: "404",
  },
});
